<template>
  <div class="row">
    <div class="col-lg-12">
      <modal :show.sync="modals.generate" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <div class="row">
              <div class="col-lg">
                <img src="@/assets/img/tick.png" width="300" />
              </div>
            </div>
            <br />
            <br />
            <br />
            <div class="row">
              <div class="col-lg">
                <h1>{{ title }}</h1>
              </div>
            </div>

            <div class="row">
              <div class="col-lg">
                <p>
                  {{ message }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <base-button class="btn-primary" @click="redirect('list')"
                  >Done</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </modal>

      <div class="row">
        <div class="col-lg-4"></div>

        <div class="col-lg-4">
          <card class="card-eprf">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  PTW
                </p>
              </div>
            </div>

            <p class="newtitle" v-if="displayflag">
              Choose File from Your Desktop
            </p>
            <p v-if="displayflag" style="font-size: 14px; color: #A5A5A5">
              Please upload PTW
            </p>
            <div class="fileinput" v-if="displayflag">
              <label
                for="ptw-uploade"
                type="primary"
                class="btn"
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
              >
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
              <div
                class="d-flex justify-content-center spinner"
                v-if="uploadload == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="ptw-uploade"
                type="file"
                ref="ptwe"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                @change="onPTWChange($event)"
              />
            </div>
            <!-- padding: 0px 20px 20px 0px; margin: 0px 30px 20px 0px -->
            <div
              v-if="uploadload == false"
              class=""
              style="height: 100px; overflow: auto; overflow-x: hidden"
            >
              <div v-for="(filee, index) in allPTW" :key="index" class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg text-left">
                      <a :href="filee.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ filee.filename }}
                        </base-button>
                      </a>
                    </div>
                    <div class="col-lg-4" v-if="displayflag">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removePTW(filee.fileid)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  eCAF
                </p>
              </div>
            </div>

            <p class="newtitle" v-if="displayflag">
              Choose File from Your Desktop
            </p>
            <p v-if="displayflag" style="font-size: 14px; color: #A5A5A5">
              Please upload eCAF
            </p>
            <div class="fileinput" v-if="displayflag">
              <label
                for="ecaf-upload"
                type="primary"
                class="btn"
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
              >
                Choose File
              </label>
              <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
              <div
                class="d-flex justify-content-center spinner"
                v-if="uploadecaf == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="ecaf-upload"
                type="file"
                ref="ecaf"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                v-on:change="oneCAFChange"
              />
            </div>
            <!-- padding: 0px 20px 20px 0px; margin: 0px 30px 20px 0px -->
            <!-- scrollable green flex-grow-1 flex-shrink-0 overflow-auto -->
            <div
              v-if="uploadload == false"
              style="height: 100px; overflow: auto; overflow-x: hidden"
              class=""
            >
              <div v-for="(filee, index) in alleCAF" :key="index" class="row">
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg text-left">
                      <a :href="filee.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ filee.filename }}
                        </base-button>
                      </a>
                    </div>
                    <div class="col-lg-4" v-if="displayflag">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeeCAF(filee.fileid)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-4"></div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            wide
            type="danger"
            @click.native="prevTab"
            class="btn-previous"
          >
            BACK
          </base-button>
          <base-button
            type="primary"
            wide
            class="btn-next"
            @click="completePTWandEcaf()"
            v-if="displayflag"
            :disabled="dis"
          >
            DONE
          </base-button>
          <base-button class="btn-primary" @click="nextTab" v-if="!displayflag">
            Next</base-button
          >
        </div>
      </div>
      <StatusModal
        :show.sync="modals.successModal"
        :message="message"
        :title="title"
      />
    </div>
  </div>
</template>

<script>
import { Circle8 } from "vue-loading-spinner";
import StatusModal from "src/components/StatusModal.vue";
import { Modal } from "src/components";
import swal from "sweetalert2";

export default {
  components: {
    Circle8,
    StatusModal,
    Modal,
  },
  data() {
    return {
      positionid: "",
      uploadload: false,
      uploadecaf: false,
      allPTW: [],
      alleCAF: [],
      modals: {
        generate: false,
        successModal: false,
      },
      message: "",
      title: "",
      button: false,
      status: 0,
      displayflag: false,
      dis: false,
    };
  },
  methods: {
    redirect(flag) {
      if ((this.flag = "list")) {
        this.$http
          .post(
            ":10001/api/v1/outgoing/product/" +
              this.$route.params.refno +
              "/ptw_ecaf/submit"
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              this.$router.push("/outgoing");
            }
          });
      }
    },
    completePTWandEcaf() {
      // this.modals.generate = true;
      // this.title = "PICKUP DETAILS SUCCESSFULLY SUBMITTED";
      // this.message = "Customer has been notified";

      this.$http
        .post(
          ":10001/api/v1/outgoing/product/" +
            this.$route.params.refno +
            "/ptw_ecaf/submit"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            setTimeout(() => {
              let parameter = {
                step: "2",
                direction: "depan",
                data: [],
              };
              this.$emit("my-event", parameter);
            }, 500);
            this.button = true;
          }
        });
    },
    onPTWChange(e) {
      this.uploadload = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/product/" +
            this.$route.params.refno +
            "/document/ptw-document",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.getData();
            this.message = "Document successfully uploaded";
            this.modals.successModal = true;
            this.uploadload = false;
          }
        });
    },
    removePTW(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/product/" +
                this.$route.params.refno +
                "/document/ptw-document/" +
                fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;
                this.$refs.ptwe.value = "";

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
        }
      });
    },
    oneCAFChange(e) {
      this.uploadecaf = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/product/" +
            this.$route.params.refno +
            "/document/ecaf-document",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Documents successfully uploaded";
            this.modals.successModal = true;
            this.uploadecaf = false;
            this.getData();
          }
        });
    },
    removeeCAF(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/product/" +
                this.$route.params.refno +
                "/document/ecaf-document/" +
                fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;
                this.$refs.ecaf.value = "";
                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
        }
      });
    },
    prevTab() {
      let parameter = {
        step: "2",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "2",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    getData() {
      this.allPTW = [] 
      this.alleCAF = [];
      this.$http
        .get(":10001/api/v1/outgoing/product/" + this.$route.params.refno)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.status = response.status.status;

            // PTW
            for (var i = 0; i < response.ptw.length; i++) {
              let obj = {
                fileid: response.ptw[i].document_id,
                filename: response.ptw[i].meta.filename,
                fileurl: response.ptw[i].url,
              };
              this.allPTW.push(obj);
            }

            // eCAF
            for (var i = 0; i < response.ecaf.length; i++) {
              let obj = {
                fileid: response.ecaf[i].document_id,
                filename: response.ecaf[i].meta.filename,
                fileurl: response.ecaf[i].url,
              };
              this.alleCAF.push(obj);
            }
          }
        });
    },
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );

    this.getData();
  },
  watch: {
    positionid() {
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    alleCAF() {
      if (this.alleCAF.length != 0 && this.allPTW.length != 0) {
        this.dis = false;
      } else {
        this.dis = true;
      }
    },
    allPTW() {
      if (this.alleCAF.length != 0 && this.allPTW.length != 0) {
        this.dis = false;
      } else {
        this.dis = true;
      }
    },
  },
};
</script>

<style scoped>
.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}
</style>
